import { CardEvent } from 'src/store/events/types';
import { Participation } from 'src/store/participant/types';
import * as moment from 'moment';
import { BikeTypesTranslations } from './../store/bus/types';
import { formatDate } from './dateHelper';

export const eventToCsvString = (event: CardEvent) => {
  if (event.buses && event.buses.length > 0) {
    return toCsvStringBusSort(event);
  } else {
    return toCsvString(event);
  }
};

export const toCsvString = (event: CardEvent) => {
  // 'data:text/csv;charset=UTF-8,%ef%bb%bf\n + '
  let str = event.title + ' - ' + formatDate(event.begins, 'DD.MM.YYYY') + '\n\n';

  str += 'Nr.;Vorname;Nachname;Tel;Betrieb;Erw/Kind;\n';

  const partis = event.participants;

  if (partis === undefined) {
    return undefined;
  }

  str += partListToCSV(partis);

  console.log(str);
  return str;
};

const partListToCSV = (partis: Participation[]): string => {
  let counter = 0;
  let str = '';
  for (const part of partis) {
    const type = part.participant.isChild ? 'Kind ' : 'Erwachsener';
    const age = part.participant.age && part.participant.age > 0 ? part.participant.age : '';
    str +=
      `${counter + 1};${part.participant.firstname};` +
      `${part.participant.lastname};\t${part.participant.phonenumber};${part.participant.creator &&
        part.participant.creator.name};${type + age};` +
      '\n';
    counter++;
  }

  return str;
};

export const toCsvStringBusNoSort = (event: CardEvent) => {
  // 'data:text/csv;charset=UTF-8,%ef%bb%bf\n + '
  let str = event.title + ' - ' + formatDate(event.begins, 'DD.MM.YYYY') + '\n\n';

  if (event.bikesAllowed) {
    str += 'Bus;Nr.;Id.;Haltestelle;Vorname;Nachname;Tel;Betrieb;Erw/Kind;Bike-Typ\n';
  } else {
    str += 'Bus;Nr.;Id.;Haltestelle;Vorname;Nachname;Tel;Betrieb;Erw/Kind\n';
  }

  if (event.buses === undefined || event.buses.length <= 0) {
    return;
  }

  let busC = 1;

  for (const bus of event.buses) {
    if (bus.stations !== undefined && bus.participants !== undefined) {
      let counter = 0;
      const parts = bus.participants;
      for (const part of parts) {
        const type = part.participant.isChild ? 'Kind ' : 'Erwachsener';
        const age = part.participant.age && part.participant.age > 0 ? part.participant.age : '';
        str +=
          `Bus ${busC};${counter + 1};${part.id};${part.station &&
            part.station.place + ' - ' + part.station.time};${part.participant.firstname};` +
          `${part.participant.lastname};\t${part.participant.phonenumber};${part.participant
            .creator && part.participant.creator.name};${type + age};` +
          `${event.bikesAllowed && part.bike && BikeTypesTranslations[part.bike.type]}` +
          '\n';
        counter++;
      }
    }
    busC++;
  }
  return str;
};

export const toCsvStringBus = (event: CardEvent) => {
  // 'data:text/csv;charset=UTF-8,%ef%bb%bf\n + '
  let str = event.title + ' - ' + formatDate(event.begins, 'DD.MM.YYYY') + '\n\n';

  if (event.bikesAllowed) {
    str += 'Bus;Nr.;Id.;Haltestelle;Vorname;Nachname;Tel;Betrieb;Erw/Kind;Bike-Typ\n';
  } else {
    str += 'Bus;Nr.;Id.;Haltestelle;Vorname;Nachname;Tel;Betrieb;Erw/Kind\n';
  }

  if (event.buses === undefined || event.buses.length <= 0) {
    return;
  }

  let busC = 1;

  for (const bus of event.buses) {
    if (bus.stations !== undefined && bus.participants !== undefined) {
      let counter = 0;
      const parts = bus.participants;
      for (const station of bus.stations) {
        const filtered = parts.filter(e => {
          return e.station && e.station.id === station.id;
        });

        for (const part of filtered) {
          const type = part.participant.isChild ? 'Kind ' : 'Erwachsener';
          const age = part.participant.age && part.participant.age > 0 ? part.participant.age : '';
          str +=
            `Bus ${busC};${counter + 1};${part.id};${part.station &&
              part.station.place + ' - ' + part.station.time};${part.participant.firstname};` +
            `${part.participant.lastname};\t${part.participant.phonenumber};${part.participant
              .creator && part.participant.creator.name};${type + age};` +
            `${event.bikesAllowed && part.bike && BikeTypesTranslations[part.bike.type]}` +
            '\n';
          counter++;
        }
      }
    }
    busC++;
  }
  return str;
};

export const toCsvStringBusSort = (event: CardEvent) => {
  // 'data:text/csv;charset=UTF-8,%ef%bb%bf\n + '
  let str = event.title + ' - ' + formatDate(event.begins, 'DD.MM.YYYY') + '\n\n';

  if (event.bikesAllowed) {
    str += 'Nr.;H-Nr.;Haltestelle;Vorname;Nachname;Tel;Betrieb;Erw/Kind;Bike-Typ\n';
  } else {
    str += 'Nr.;H-Nr.;Haltestelle;Vorname;Nachname;Tel;Betrieb;Erw/Kind\n';
  }

  if (event.buses === undefined || event.buses.length <= 0) {
    return;
  }

  let bcount = 1;
  const parts = [];
  for (const bus of event.buses) {
    if (bus.stations !== undefined && bus.participants !== undefined) {
      for (const part of bus.participants) {
        parts.push({ ...part, bus: bcount });
      }
    }

    bcount++;
  }

  if (event.buses[0] !== undefined && event.buses[0].stations !== undefined) {
    let stations = event.buses[0].stations;
    let counter = 0;
    stations = stations.sort((a, b) => {
      const start = moment(a.time, 'HH:mm');
      const end = moment(b.time, 'HH:mm');
      if (start.isBefore(end)) {
        return -1;
      } else if (start.isAfter(end)) {
        return 1;
      } else {
        return 0;
      }
    });

    for (const station of stations) {
      const filtered = parts.filter(e => {
        return e.station && e.station.id === station.id;
      });
      let countPerStation = 1;
      for (const part of filtered) {
        const type = part.participant.isChild ? 'Kind ' : 'Erwachsener';
        const age = part.participant.age && part.participant.age > 0 ? part.participant.age : '';
        str +=
          `${counter + 1};${countPerStation++};${part.station &&
            part.station.place + ' - ' + part.station.time};${part.participant.firstname};` +
          `${part.participant.lastname};\t${part.participant.phonenumber};${part.participant
            .creator && part.participant.creator.name};${type + age};` +
          `${event.bikesAllowed && part.bike && BikeTypesTranslations[part.bike.type]}` +
          '\n';
        counter++;
      }
    }
  }
  return str;
};



// WEBPACK FOOTER //
// ./src/utils/csvHelper.ts